import iconList from './icons';

import type { IIcon, TIconName } from './types';

export const iconNameKeys = Object.keys(iconList) as TIconName[];

const Icon = ({ fillColor = '', iconName = 'Facebook', size = -1, ...rest }: IIcon) => {
  const SpecificIcon = iconList[iconName];

  if (!SpecificIcon) {
    return null;
  }

  // set height of the icon. Default is 1em, auto will use the default size of the icon
  let style: { style?: React.CSSProperties; } = {};
  if (size !== 'auto') {
    style = { 
      style: { 
        height: size !== -1 ? `${size}rem` : '1em',
      },
    };
  }

  return (
    <SpecificIcon
      color={fillColor}
      {...style }
      {...rest}
    />
  );
};

export default Icon;
